<template>
  <v-card class="chart-card" min-height="100%">
    <div class="chart-cnt">
      <canvas :id="id">
        <p>Placeholder text</p>
      </canvas>
    </div>
    <v-card-title>{{title}}</v-card-title>
    <!-- diagraminformation från servern?-->
    <v-card-text>
      {{ description }}
    </v-card-text>
  </v-card>
</template>

<script>
import Chart from 'chart.js'
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    chartData: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.createChart()
  },
  computed: {
    hasData() {
      return !!this.chartData
    }
  },
  methods: {
    createChart() {
      const ctx = document.getElementById(`${this.id}`).getContext('2d')
      // eslint-disable-next-line no-new
      new Chart(ctx, this.chartData)
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-cnt {
  position: relative;
  max-width: 500px;
  padding: 1rem;
  margin: 0 auto;
}

.chart-card{
  max-width: 520px;
}
</style>
